<h2 i18n="@@mergeCustomer.heading.reviewMergeCustomer">Review & merge customer</h2>
<p i18n="@@mergeCustomer.subHeading.reviewMergeCustomer">
  Both customer data sets will be merged into the newly assambled one.
  Ticketing and merchandise invoices, last contacts and reminders will be transferred to the merged customer.
  Not selected addresses and customer basic information will be lost. The merge can not be revoked!
</p>

<div class="esf-info-tile-grid esf-info-tile-grid--3" style="justify-content: space-between">
  <div class="esf-info-tile-grid"></div>
  <div class="esf-info-tile-grid">
    <h3 i18n="@@mergeCustomer.heading.mergedCustomer">Merged customer</h3>

    <app-merge-customer-data [id]="'firstCustomerData'"
                             [customer]="combinedCustomerData"
                             [type]="tablesTranslations.i18nCustomerData"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>

    <app-merge-customer-data [id]="'firstCustomerCommunication'"
                             [customer]="combinedCustomerData"
                             [type]="tablesTranslations.i18nComunicationData"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>

    <app-merge-customer-data [id]="'firstCustomerAttributes'"
                             [customer]="combinedCustomerData"
                             [type]="tablesTranslations.i18nAttribute"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>

    <div *ngIf="selectedClub.isCrmMembershipActive">
      <app-merge-customer-data [id]="'firstCustomerMembership'"
                               [customer]="combinedCustomerData"
                               [type]="tablesTranslations.i18nMembership"
                               [countries]="countries"
                               [selectedClub]="selectedClub"
                               [viewOnly]="true">
      </app-merge-customer-data>
    </div>

    <div *ngIf="selectedClub.isCampaiMembershipActive">
      <app-merge-customer-data [id]="'firstCustomerMembership'"
                               [customer]="combinedCustomerData"
                               [type]="tablesTranslations.i18nMembershipCampai"
                               [countries]="countries"
                               [selectedClub]="selectedClub"
                               [viewOnly]="true">
      </app-merge-customer-data>
    </div>

    <app-merge-customer-data [id]="'firstCustomerStandardAddress'"
                             [customer]="combinedCustomerData"
                             [type]="tablesTranslations.i18nStandardAddress"
                             [countries]="countries"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>
  <div class="esf-info-tile-grid"></div>
</div>
